import { render, staticRenderFns } from "./GraphDetail02.vue?vue&type=template&id=328c4138&scoped=true&"
import script from "./GraphDetail02.vue?vue&type=script&lang=js&"
export * from "./GraphDetail02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c4138",
  null
  
)

export default component.exports